import { user_outline, office_building } from '../../../../../../../assets/hostedassets';
import type { AuditorYearRow, AuditorCommentsCellProps } from '../../auditorCommentsDrawer.types';
import { NO_DATA_LABEL, QUALIFICATION_LABELS } from '../../constants';
import styles from './AuditorCommentsCells.module.scss';

export const AuditorDetails = ({ row }: { row: AuditorYearRow }) => {
    if (!row.auditorName && !row.auditorFirmName) {
        return <span className={styles.NoData}>{NO_DATA_LABEL}</span>;
    }
    return (
        <>
            {row.auditorName && (
                <div className={styles.AuditorDetailItem}>
                    <img src={user_outline} alt="" width="16" height="16" className={styles.AuditorNameIcon} />
                    <span>{row.auditorName}</span>
                </div>
            )}
            {row.auditorFirmName && (
                <div className={styles.AuditorDetailItem}>
                    <img src={office_building} alt="" width="16" height="16" className={styles.AuditorFirmIcon} />
                    <span>{row.auditorFirmName}</span>
                </div>
            )}
        </>
    );
};

export const QualificationBadge = ({ hasAdverseRemarks }: { hasAdverseRemarks: boolean | null }) => {
    if (hasAdverseRemarks == null) return null;
    if (hasAdverseRemarks) {
        return <div className={`${styles.QualificationBadge} ${styles.Qualified}`}>{QUALIFICATION_LABELS.QUALIFIED}</div>;
    }
    return <div className={`${styles.QualificationBadge} ${styles.NotQualified}`}>{QUALIFICATION_LABELS.NOT_QUALIFIED}</div>;
};

export const CommentsList = ({ comments }: { comments: string[] }) => {
    if (!comments.length) return null;
    return (
        <ul className={styles.CommentsList}>
            {comments.map((comment, idx) => (
                <li key={idx}>{comment}</li>
            ))}
        </ul>
    );
};

export const AuditorCommentsContent = ({ row, showBadge = true }: AuditorCommentsCellProps) => {
    const showsQualification = showBadge && row.reportHasAdverseRemarks != null;
    const hasComments = row.auditorComments.length > 0;

    if (!showsQualification && !hasComments) {
        return <span className={styles.NoData}>{NO_DATA_LABEL}</span>;
    }

    return (
        <>
            {showBadge && <QualificationBadge hasAdverseRemarks={row.reportHasAdverseRemarks} />}
            <CommentsList comments={row.auditorComments} />
        </>
    );
};

export const DirectorCommentsContent = ({ row }: { row: AuditorYearRow }) => {
    const hasBadgeOffset = row.reportHasAdverseRemarks != null;
    if (!row.directorComments.length) {
        return <span className={`${styles.NoData} ${hasBadgeOffset ? styles.BadgeOffset : ''}`}>{NO_DATA_LABEL}</span>;
    }
    return (
        <div className={hasBadgeOffset ? styles.BadgeOffset : undefined}>
            <CommentsList comments={row.directorComments} />
        </div>
    );
};
